import { useUnit } from 'effector-react'

import { $gameConnectConfig } from '@/entities/game'
import { $portalProfile } from '@/entities/profile/portal'

import { VersionBadge } from '../version-badge/view'

export type DeployVersionInfoProps = {
    className?: string
}

export function DeployVersionInfo({ className }: DeployVersionInfoProps) {
    const connectConfig = useUnit($gameConnectConfig)
    const deployVersion = connectConfig?.info.deploy_version.toString() ?? ''
    const profile = useUnit($portalProfile)

    if (!deployVersion || profile?.tester !== true) {
        return null
    }

    return <VersionBadge label="Deploy" value={deployVersion} className={className} />
}
